import React, { useState } from "react";
import emailjs from "emailjs-com"; // ✅ ADDED

import "./contactus.css";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };





const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    await emailjs.send(
      "service_s8vmssj",
      "template_24mj9cg",
      {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
      },
      "KHJdOgdMbWhlPc34P"
    );

    // ✅ Show success UI (non-blocking)
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);

    // ✅ Reset form
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });

  } catch (error) {
    console.error("EmailJS error:", error);
    alert("Failed to send message. Please try again later.");
  } finally {
    setIsSubmitting(false);
  }
};




  return (
    <div className="lotus-container">
      {/* Decorative header */}
      <div className="lotus-header">
        <h1 className="serene-title">Contact Sri Dhamma Samadhi Buddhist Center</h1>
      </div>

      <p className="dharma-text">
        We welcome you with open hearts to connect with us for any inquiries, spiritual guidance, 
        or to participate in our programs. May our communication bring peace and understanding.
      </p>

      <div className="contact-grid">
        {/* Contact Information Section */}
        <div className="contact-info-section">
          <div className="golden-border">
            <h2 className="section-title">Visit Us</h2>

            <div className="contact-item">
              <div>
                <h3>Address</h3>
                
                <p>4 Schotters Rd, <br />Mernda, VIC 3754</p>
              </div>
            </div>

            <div className="contact-item">
              <div>
                <h3>Phone</h3>
                <p>+61 45 12 900 85</p>
              </div>
            </div>

            <div className="contact-item">
              <div>
                <h3>Email</h3>
                <p>ehipassikobuddhistcenter@gmail.com</p>
              </div>
            </div>

            <div className="opening-hours">
              <h3>Opening Hours</h3>
              <p>Monday - sunday: 06: 00 am - 10:00 pm</p>
              {/* <p>Weekends: Meditation sessions only</p> */}
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="contact-form-section">
          <div className="golden-border">
            <h2 className="section-title">Send Your Message</h2>

            {showSuccess && (
              <div className="success-message">
                <p>Your message has been sent with loving-kindness. We will respond soon.</p>
              </div>
            )}

            <form className="dharma-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Enter subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Share your thoughts with us..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Send with Metta"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Blessing Footer */}
      <footer className="blessing-footer">
        <p>
          May you be well. May you be happy. May you be free from suffering.<br />
          We look forward to connecting with you on the path of Dharma.
        </p>
      </footer>

      <div className="map-ehipassiko-buddhist-center-container">
  <div className="map-header">
    <h1 className="find-us-heading">Find Us</h1>
    <p className="map-subheading">Visit Ehipassiko Buddhist Center in Bundoora</p>
  </div>
  


  <div className="map-wrapper">
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3161.056019728157!2d145.09949847587535!3d-37.60084057202968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad64ae65dd4c801%3A0x910bd75ae0831c42!2s4%20Schotters%20Rd%2C%20Mernda%20VIC%203754%2C%20Australia!5e0!3m2!1sen!2slk!4v1765596337254!5m2!1sen!2slk" 
      className="google-map"
      allowFullScreen 
      loading="lazy" 
      referrerPolicy="no-referrer-when-downgrade"
      title="Ehipassiko Buddhist Center Location"
    ></iframe>
  </div>
  
  <div className="map-footer">
    <p className="map-address">
    4 Schotters Rd, Mernda VIC 3754, Australia
    </p>
  </div>
</div>

    </div>
  );
}

export default ContactUs;
